import { ValeurComposantSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const ValeurComposantModel: SelectorModel = {
  name: 'valeurComposants',
  getSelector: ValeurComposantSelectors.selectAllValeurComposantsDictionary,
  isReady: ValeurComposantSelectors.selectIsReadyValeurComposant
};
